const AdminContactSupportValues = (showData = null) => {
  const data = showData?.data || showData;
  return {
    assigned_to_id: data?.assigned_to_id || "",
    participant_id_1: data?.participant_id_1 || "",
    participant_id_2: data?.participant_id_2 || "",
    opening_message: data?.opening_message || "",
    reference_transactio_id: data?.reference_transactio_id || "",
    reference_username: data?.reference_username || "",
    contact_support_reason_id: data?.contact_support_reason_id || "",
    admin_comment: data?.admin_comment || "",
  };
};

export default AdminContactSupportValues;
